// Deterministic ping/pong scenarios expressed as engine decisions. Each one
// replays from a seed with no hidden state, so a scenario doubled as a test
// fixture and as future Sandbox content.
import { defaultConfig } from './model';

export const PING = (from, to) => ({
  op: 'deliver',
  select: { kind: 'message', from, to, msgType: 'ping' },
});
export const PONG = (from, to) => ({
  op: 'deliver',
  select: { kind: 'message', from, to, msgType: 'pong' },
});
export const COMMAND = (to, command) => ({
  op: 'submit',
  to,
  command,
  label: 'submit ping command',
});
export const RETRY = (node, pingId) => ({
  op: 'fire',
  select: { kind: 'timer', to: node, timerKey: 'retry:' + pingId },
});
const CMD = (to, command) => ({ op: 'deliver', select: { kind: 'clientCommand', to } });

export function normalExchange() {
  const config = defaultConfig();
  return {
    config,
    seed: 1,
    decisions: [
      COMMAND('A', { op: 'sendPing', key: 'x', value: 1 }),
      CMD('A'),
      PING('A', 'B'),
      PONG('B', 'A'),
    ],
  };
}

// Phase 1 acceptance case: the first pong is lost, the retry resends the same
// ping id, and the ponger answers from its cache without re-executing.
export function droppedResponseReturnsCachedResult() {
  const config = defaultConfig();
  return {
    config,
    seed: 7,
    decisions: [
      COMMAND('A', { op: 'sendPing', key: 'x', value: 1 }),
      CMD('A'),
      PING('A', 'B'),
      { ...PONG('B', 'A'), op: 'drop' },
      RETRY('A', 'A#1'),
      PING('A', 'B'),
      PONG('B', 'A'),
    ],
  };
}

export function duplicatePingSuppressed() {
  const config = defaultConfig();
  return {
    config,
    seed: 3,
    decisions: [
      COMMAND('A', { op: 'sendPing', key: 'y', value: 2 }),
      CMD('A'),
      { ...PING('A', 'B'), op: 'duplicate' },
      PING('A', 'B'),
      PING('A', 'B'),
      PONG('B', 'A'),
      PONG('B', 'A'),
    ],
  };
}

// Crash the ponger with state retained: the ping waits, then completes after
// restart with no re-execution.
export function crashRetainAndRestart() {
  const config = defaultConfig();
  return {
    config,
    seed: 11,
    decisions: [
      COMMAND('A', { op: 'sendPing', key: 'z', value: 3 }),
      CMD('A'),
      { op: 'crash', node: 'B' },
      { op: 'restart', node: 'B' },
      PING('A', 'B'),
      PONG('B', 'A'),
    ],
  };
}

export const ALL_SCENARIOS = {
  normalExchange,
  droppedResponseReturnsCachedResult,
  duplicatePingSuppressed,
  crashRetainAndRestart,
};
